import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import RootState from 'store/state';
import { Button } from '@missionlabs/smartagent-app-components';
import { login } from 'store/user/user.actions';
import LoginSplash from '../LoginSplash';

interface Props extends ReturnType<typeof mapStateToProps> {
    login: (username?: string, password?: string) => void;
}

class LoginExternal extends PureComponent<Props> {
    componentDidMount() {
        //Login process if not logged out
        if (!this.props.logout) {
            setTimeout(this.props.login, 1000);
        }
    }
    onRetry = () => {
        window.location.reload();
    };
    render() {
        const { authError, authenticating, authenticated, logout } = this.props;

        return (
            <>
                {authenticating || authenticated ? (
                    <div className="row column row middle">
                        <div className="sa-login-text">
                            {authenticating || authenticated
                                ? 'Authenticating...'
                                : "You're using external log in, please wait"}
                        </div>
                    </div>
                ) : authError ? (
                    <div className="row column row middle" aria-live="polite">
                        <div className="sa-login-text sa-login-error">{authError}</div>
                        <Button styling="primary" large round onClick={this.onRetry}>
                            Retry
                        </Button>
                    </div>
                ) : (
                    <LoginSplash onClick={this.props.login} loading={!logout} />
                )}
            </>
        );
    }
}

function mapStateToProps(state: RootState) {
    return {
        ...state.auth,
        appError: state.app.error,
    };
}

export default connect(mapStateToProps, { login })(LoginExternal);
